import React from 'react';

import styles from './Field.module.scss';

export interface FieldProps {
    description?: React.ReactElement;
    error?: string;
    fieldDescription?: string;
    fieldTitle: string;
    required?: boolean;
}

export const Field: React.FC<FieldProps> = ({
    children,
    error,
    required,
    description,
    fieldTitle,
    fieldDescription,
}) => {
    return (
        <div className={styles.formFieldContainer}>
            <h4 className={styles.formFieldTitle}>
                {fieldTitle} {required && <span className={styles.formFieldAsterisk}>*</span>}
            </h4>
            {fieldDescription && <div className={styles.formFieldDescription}>{fieldDescription}</div>}
            <div>
                {children}
                {error && <div className={styles.formFieldError}>{error}</div>}
                {description}
            </div>
        </div>
    );
};
